import { render, staticRenderFns } from "./LiefengTree.vue?vue&type=template&id=392c4183&scoped=true&"
import script from "./LiefengTree.vue?vue&type=script&lang=js&"
export * from "./LiefengTree.vue?vue&type=script&lang=js&"
import style0 from "./LiefengTree.vue?vue&type=style&index=0&id=392c4183&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392c4183",
  null
  
)

export default component.exports